Ext.define('SA.view.sidebar.data.DataSidebar.LastSelectedEditionOptionsByCensusReleaseId', {
    constructor() {
        this.options = new Map();
    },

    get(censusReleaseId) {
        return this.options.get(censusReleaseId.toString()) ?? null;
    },

    set(censusReleaseId, lastSelectedEditionOption) {
        this.options.set(censusReleaseId.toString(), lastSelectedEditionOption);
    }
});